"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RibbonSides = exports.RibbonFolds = void 0;
var RibbonSides = {
  Left: "left",
  Right: "right"
};
exports.RibbonSides = RibbonSides;
var RibbonFolds = {
  Up: "up",
  Down: "down"
};
exports.RibbonFolds = RibbonFolds;